<template>
  <section class="options">
    <section class="options__title">
      <small> {{ $t("helpers.chat.greeting") }} </small>
      <small> {{ $t("helpers.chat.select_option_to_continue") }} </small>
    </section>

    <section
      class="option"
      v-for="(item, index) in options"
      :key="index"
      @click="setComponent(item)"
    >
      <section class="option__content">
        <span class="option__content__title"> {{ item.title }}</span>
        <v-icon size="18">mdi-chevron-right</v-icon>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: "HelpOptionsComponent",

  data: () => ({
    isActive: null,
  }),

  computed: {
    options() {
      return [
        {
          title: this.$t("helpers.chat.im_doubt"),
          component: "Doubt",
        },
        {
          title: this.$t("helpers.chat.need_help"),
          component: "Account",
        },
      ];
    },
  },

  methods: {
    setComponent({ component }) {
      this.$emit("changeComponent", component);
    },
  },
};
</script>

<style lang="scss" scoped>
.options {
  display: flex;
  flex-direction: column;
  gap: 6px;

  .options__title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    margin-bottom: 10px;
    font-size: 16px;
  }

  .option {
    .option__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #fafafa;
      border-radius: 12px;
      padding: 12px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      cursor: pointer;
      font-size: 13px;

      &:hover {
        background: #eeeeee;
      }
    }
  }
}
</style>
